import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { authFetch } from "../../utils/api";
import '../../styles/admin/admin-form.css'; 

const DIAS_SEMANA = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo'];
const HORARIO_POR_DEFECTO = DIAS_SEMANA.reduce((acc, d) => ({...acc, [d]: []}), {});

export default function FormularioCorredor() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = Boolean(id); 

  const [formData, setFormData] = useState({
    nombre: '', correoElectronico: '', telefono: '', municipio: '', estado: '', direccion: '', imagenUrl: '', 
    horario: HORARIO_POR_DEFECTO 
  });

  const [pageLoading, setPageLoading] = useState(isEditMode);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  
  // --- NUEVO ---
  const [generalHorario, setGeneralHorario] = useState([{ abre: "", cierra: "" }]);

  useEffect(() => {
    if (isEditMode) {
      setPageLoading(true);
      setError(null);
      authFetch(`/api/Agencia/${id}`)
        .then(res => { if (!res.ok) throw new Error('Error al cargar.'); return res.json(); })
        .then(data => {
          setFormData({
            nombre: data.nombre || '',
            correoElectronico: data.correoElectronico || '',
            telefono: data.telefono || '',
            municipio: data.municipio || '',
            estado: data.estado || '',
            direccion: data.direccion || '',
            imagenUrl: data.urlImagen || data.UrlImagen || data.url_imagen || '',
            horario: { ...HORARIO_POR_DEFECTO, ...(data.horario || {}) }
          });
        })
        .catch(err => setError(err.message))
        .finally(() => setPageLoading(false));
    }
  }, [id, isEditMode]); 

  const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleHorarioChange = (dia, index, campo, value) => {
    setFormData(prev => {
        const nuevoHorario = JSON.parse(JSON.stringify(prev.horario));
        if (nuevoHorario[dia][index]) nuevoHorario[dia][index][campo] = value;
        return { ...prev, horario: nuevoHorario };
    });
  };

  const addTurno = (dia) => {
    setFormData(prev => {
        const nuevoHorario = { ...prev.horario };
        nuevoHorario[dia] = [...(nuevoHorario[dia] || []), { abre: '', cierra: '' }];
        return { ...prev, horario: nuevoHorario };
    });
  };

  const removeTurno = (dia, index) => {
    setFormData(prev => {
        const nuevoHorario = { ...prev.horario };
        nuevoHorario[dia] = nuevoHorario[dia].filter((_, i) => i !== index);
        return { ...prev, horario: nuevoHorario };
    });
  };

  // --- LÓGICA CONFIGURACIÓN GENERAL ---
  const handleGeneralChange = (index, campo, value) => {
    const nuevos = [...generalHorario];
    nuevos[index] = { ...nuevos[index], [campo]: value };
    setGeneralHorario(nuevos);
  };
  const addGeneralTurn = () => setGeneralHorario([...generalHorario, { abre: "", cierra: "" }]);
  const removeGeneralTurn = (index) => setGeneralHorario(generalHorario.filter((_, i) => i !== index));

  const aplicarHorarioGeneral = () => {
    const turnosValidos = generalHorario.filter(t => t.abre && t.cierra);
    if (turnosValidos.length === 0) { alert("⚠️ Turnos inválidos."); return; }
    if (!window.confirm("¿Aplicar a Lunes-Viernes?")) return;
    setFormData(prev => {
      const nuevoHorario = { ...prev.horario };
      ["lunes", "martes", "miercoles", "jueves", "viernes"].forEach(dia => {
        nuevoHorario[dia] = turnosValidos.map(t => ({ ...t }));
      });
      return { ...prev, horario: nuevoHorario };
    });
    alert("✅ Aplicado.");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const url = isEditMode ? `/api/Agencia/${id}` : `/api/Agencia`;
    const method = isEditMode ? 'PUT' : 'POST';
    const payload = { ...formData, UrlImagen: formData.imagenUrl, tipo: "Corredor público", ...(isEditMode && { id }) };
    
    try {
      const response = await authFetch(url, { method, body: JSON.stringify(payload) });
      if (!response.ok) throw new Error(await response.text());
      alert(isEditMode ? 'Actualizado' : 'Guardado');
      navigate('/admin/corredorPublico'); 
    } catch (err) { setError(err.message); alert('Error: ' + err.message); } 
    finally { setIsSubmitting(false); }
  };

  return (
    <div className="form-container">
      <button className="btn-back" onClick={() => navigate(-1)} disabled={isSubmitting}>Volver</button>
      <h1>{isEditMode ? 'Editar Corredor' : 'Nuevo Corredor'}</h1>
      {error && <div className="form-error">Error: {error}</div>}
      {pageLoading && <div className="form-loading">Cargando...</div>}
      {!pageLoading && (
        <form onSubmit={handleSubmit}>
          <div className="form-group"><label>Nombre</label><input name="nombre" value={formData.nombre} onChange={handleChange} required /></div>
          <div className="form-group"><label>Imagen</label><input name="imagenUrl" value={formData.imagenUrl} onChange={handleChange} /></div>
          <div className="form-group"><label>Correo</label><input name="correoElectronico" value={formData.correoElectronico} onChange={handleChange} /></div>
          <div className="form-group"><label>Teléfono</label><input name="telefono" value={formData.telefono} onChange={handleChange} /></div>
          <div className="form-row">
            <div className="form-group"><label>Municipio</label><input name="municipio" value={formData.municipio} onChange={handleChange} /></div>
            <div className="form-group"><label>Estado</label><input name="estado" value={formData.estado} onChange={handleChange} /></div>
          </div>
          <div className="form-group"><label>Dirección</label><textarea name="direccion" value={formData.direccion} onChange={handleChange}></textarea></div>
          
          <fieldset>
            <legend>Horarios</legend>
            <div style={{ backgroundColor: '#e0f2fe', padding: '15px', borderRadius: '8px', marginBottom: '20px', border: '2px solid #0ea5e9' }}>
               <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                  <h4 style={{ margin: 0, color: '#0369a1' }}>⚡ Configurar Horario General</h4>
                  <button type="button" onClick={addGeneralTurn} style={{ fontSize: '0.8em', padding: '4px', border: '1px solid #0369a1', borderRadius: '4px' }}>+ Turno</button>
               </div>
               {generalHorario.map((t, i) => (
                  <div key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-end', marginBottom: '5px' }}>
                     <div><label>Abre</label><input type="time" value={t.abre} onChange={e=>handleGeneralChange(i,'abre',e.target.value)} /></div>
                     <div><label>Cierra</label><input type="time" value={t.cierra} onChange={e=>handleGeneralChange(i,'cierra',e.target.value)} /></div>
                     {generalHorario.length > 1 && <button type="button" onClick={()=>removeGeneralTurn(i)} style={{background:'#ef4444', color:'white', border:'none'}}>x</button>}
                  </div>
               ))}
               <button type="button" onClick={aplicarHorarioGeneral} style={{ marginTop: '10px', backgroundColor: '#0284c7', color: 'white', padding: '8px', border: 'none', borderRadius: '4px' }}>Aplicar</button>
            </div>

            {DIAS_SEMANA.map((dia) => (
              <div key={dia} className="horario-dia">
                <div className="horario-dia-header"><h3>{dia}</h3><button type="button" onClick={()=>addTurno(dia)} className="btn-add-turno">+ Añadir</button></div>
                {formData.horario[dia].map((t, i) => (
                   <div key={i} className="horario-turno">
                      <div><label>Abre</label><input type="time" value={t.abre} onChange={e=>handleHorarioChange(dia,i,'abre',e.target.value)} /></div>
                      <div><label>Cierra</label><input type="time" value={t.cierra} onChange={e=>handleHorarioChange(dia,i,'cierra',e.target.value)} /></div>
                      <button type="button" onClick={()=>removeTurno(dia,i)} className="btn-remove-turno">x</button>
                   </div>
                ))}
              </div>
            ))}
          </fieldset>
          <button type="submit" className="btn-submit" disabled={isSubmitting}>Guardar</button>
        </form>
      )} 
    </div>
  );
}